import { Address } from "../dto/interfaces";

/**
 * Builds a full address string from the Address object.
 * Filters out any empty or undefined parts.
 */
const buildFullAddress = (address: Address): string => {
    const addressParts = [
        address.addressLine1,
        address.addressLine2,
        address.street,
        address.city,
        address.state,
        address.country,
        address.pincode
    ];
    return addressParts.filter((part) => part).join(", ");
};

/**
 * Generates a key-less Google Maps embed URL for an iframe.
 * Uses the "search" mode, which is very reliable.
 */
export const getGoogleMapsEmbedUrl = (address: Address): string => {
    const fullAddress = buildFullAddress(address);
    return `https://www.google.com/maps?q=${encodeURIComponent(fullAddress)}&output=embed`;
};

/**
 * Generates a Google Maps URL for the "Get Directions" button.
 */
export const getGoogleMapsDirectionsUrl = (address: Address): string => {
    const fullAddress = buildFullAddress(address);
    return `https://www.google.com/maps?daddr=${encodeURIComponent(fullAddress)}`;
};
